<script>
    import Conexoes from "../../Classes/Conexoes";
    import Constantes from "../../Classes/Constantes";
    import Navigate from "../../Classes/Navigate";
    import { DadosLogin, DadosPlano } from "../../Classes/Stores";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    
    const conexao = new  Conexoes();
    let isLoading=false;
    
    let navi = new Navigate();
    let id_usuario =$DadosLogin.id_usuario;
    export let precoEstatico = 0.0;

    export let titulo;
    export let id_plano;
    export let pacote = 0;
    export let descricao;
    export let destaque;
    export let anual = 0;
    export let icone; // Novo: Ícone da medalha ou distintivo
    let alunos = pacote; // Novo: Número de alunos para calcular o valor por aluno
    $: preco = precoEstatico * pacote;
    function Contratar() {
        isLoading=true;
        let parametros = {
            id_plano: id_plano,
            
            pacote: pacote,
        };

        $DadosPlano=parametros;
        
        navi.goTo(Constantes.tela_pre_pagamento_plano);
       
        
    }
</script>
<LoadingTela {isLoading} />
<div class="card">
    <div class="titulo">
        <span class="titulo-icon"><i class={icone}></i></span>
        {titulo}
    </div>
    {#if anual == 0}
        <div class="preco">R$ {preco.toFixed(2)} / mês</div>
    {:else}
        <div class="preco">R$ {(preco * 12).toFixed(2)} / ano</div>
        <div class="valor-por-aluno">
            (Equivalente a R$ {preco.toFixed(2)} por mês)
        </div>
    {/if}
    <div class="valor-por-aluno">(R$ {precoEstatico} por aluno)</div>
    <!-- Novo: Valor por aluno -->
    <div class="descricao">{descricao}</div>
    {#if destaque}
        <div class="destaque m-2">{destaque}</div>
    {/if}
    <button on:click={Contratar}>Contratar</button>
</div>

<style>
    .card {
        border: 1px solid #ddd;
        padding: 20px;
        width: 220px;
        text-align: center;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        position: relative;
        transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
    }

    .card:hover {
        transform: scale(1.05);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    .titulo {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .titulo-icon {
        margin-right: 8px;
    }
    .bronze {
        color: #cd7f32;
    }
    .silver {
        color: #c0c0c0;
    }
    .gold {
        color: #ffd700;
    }
    .preco {
        font-size: 24px;
        color: #28a745;
        font-weight: bold;
        margin: 15px 0;
    }

    .valor-por-aluno {
        font-size: 14px;
        color: #6c757d;
        margin-bottom: 10px;
    }

    .destaque {
        font-size: 14px;
        color: #007bff;
        margin-top: 10px;
    }

    button {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 10px 20px;
        font-size: 16px;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    button:hover {
        background-color: #0056b3;
    }
</style>
